import React, { Component } from 'react';

import { restbaseurl } from '../../globals/constants';
import { RestDataSource } from '../../utils/RestDataSource';
import { LoadingSpinner } from '../../utils/LoadingSpinner';
import BottomAlert from '../../globals/uicomps/BottomAlert'

import { Route, Routes, Navigate } from "react-router-dom";
import { LoginHeader } from '../../login/LoginHeader';
import LoginForm from '../../login/LoginForm';
import VerifyOTP from '../../login/VerifyOTP';
import UserInfo from '../../models/UserInfo';
import { setValue, getValue } from '../../globals/utils';
import { WithRouterHooks } from 'withFunctionHooks';
import * as ls from "local-storage";

export class CandidateLoginLayout extends Component {

     constructor(props) {
          super(props);
          // Don't clear storage here - it wipes out tokens set by RestDataSource
          // Only clear if user explicitly logs out or navigates away

          let index = this.props.location.pathname.lastIndexOf("/");
          let step = this.props.location.pathname.substr(index + 1).trim()
          console.log(index, step);
          this.state = {
               alertMsg: null,
               userData: null,
               forgotPassword: false,
               otpVerified: false,
               isSuspended: false,
               anotherWay: false,
               step: (step === '' || step === 'cdHome') ? 'login' : step,
               fullLoading: false
          };
          this.userid = UserInfo.getUserid()
          this.username = UserInfo.getUsername()
     }

     componentDidMount = async () => {
          document.body.classList.add('login-bg')
          const payloadData = await getValue();
          if (payloadData && payloadData['isloggedin'] && payloadData['roleCode'] === 'candidate') {
               if (payloadData['applicantId']) {
                    document.location.href = "/candidate/bgvForm/entry";
                    // }else if(this.userid){
                    //      document.location.href = "/dashboard";
               } else {
                    //do nothing
               }

          }
          console.log("login layout mount")
     }


     validateLogin = async (username, password) => {
          password = password.trim();
          this.dataSource = new RestDataSource(`${restbaseurl}/login/applicantAuth`)
          this.setState({ loading: true, alertMsg: null });

          try {
               // Encrypt credentials before sending (same as regular login)
               const { encryptCredentials } = await import('../../utils/CredentialEncryption');
               const encryptedCreds = await encryptCredentials(username, password);

               this.dataSource.GetData(
                    async respData => {
                         console.log('Candidate login response:', respData);
                         // Backend returns: {status: true, message: 'success', data: {...}, c1: '...'}
                         // Or error: {status: false, error: '...'} or {status: true, message: 'Invalid...'}
                         const isSuccess = respData.status === true && respData.message === 'success';

                         if (isSuccess && respData.data) {
                              const responseData = respData.data;
                              // Store all candidate data - RestDataSource should have already stored most of it
                              // But ensure critical fields are set
                              if (responseData.applicantId) {
                                   await setValue('applicantId', responseData.applicantId);
                              }
                              if (responseData.uploadBy) {
                                   await setValue('uploadBy', responseData.uploadBy);
                              }
                              if (responseData.clientLogo) {
                                   await setValue('clientLogo', responseData.clientLogo);
                              }
                              // Ensure isloggedin is set (RestDataSource should have done this, but double-check)
                              await setValue('isloggedin', true);
                              await setValue('roleCode', 'candidate');

                              this.setState({ loading: false }, () => this.loginSuccess())
                         }
                         else if (respData.concurrentSession === true) {
                              // Handle concurrent session - user already logged in elsewhere
                              this.setState({
                                   loading: false,
                                   alertMsg: respData.message || 'This account is already logged in from another device. Please logout from the active session to continue.'
                              });
                         }
                         else {
                              // Handle error responses
                              const errorMsg = respData.error || respData.message || 'Login failed. Please try again.';
                              this.setState({ loading: false, alertMsg: errorMsg });
                         }
                    },
                    { "username": encryptedCreds.username, "password": encryptedCreds.password, "gtoken": "test" },
                    "POST"
               );
          } catch (error) {
               console.error('Login error:', error);
               this.setState({ loading: false, alertMsg: 'Network error. Please check your connection and try again.' });
          }
     }

     resendOTP = () => {
          this.checkResend = new RestDataSource(`${restbaseurl}/login/applicantResendOtp`)
          this.showAlert(null);
          this.setState({ loading: true }, async () => {
               const applicantId = await getValue('applicantId');
               this.checkResend.GetData(
                    async resendResponse => {
                         this.setState({ loading: false })
                         if (resendResponse.isBlocked) {
                              this.changeStepValue("blocked")
                         }
                         else {

                              await setValue('remainingTries', resendResponse.remainingTries)
                              console.log("otp-resent")
                         }
                    },
                    { 'applicantId': applicantId, "username": UserInfo.getUsername() },
                    "POST"
               );
          })
     }

     verifyOTP = (otp) => {

          this.verifyOTPReq = new RestDataSource(`${restbaseurl}/login/applicantOtpLogin`)
          this.showAlert(null);
          this.setState({ loading: true }, async () => {
               const applicantId = await getValue('applicantId');
               this.verifyOTPReq.GetData(
                    respData => {
                         this.setState({ loading: false })
                         if (respData.message === 'success') {
                              this.loginSuccess();
                         }
                         else {
                              if (respData.isBlocked === true) {
                                   this.changeStepValue("blocked")
                              }
                              else {
                                   this.showAlert(respData.message)
                              }

                         }
                    },
                    { 'applicantId': applicantId, "username": UserInfo.getUsername(), "otp": otp },
                    "POST"
               );
          })
     }

     loginSuccess = async () => {
          try {
               this.setState({ fullLoading: true });

               // Get current payload
               let current = null;
               try {
                    current = await getValue() || {};
               } catch (error) {
                    console.warn('Error getting value, will set fresh:', error);
                    current = {};
               }

               const applicantId = current.applicantId;
               const userId = current.userId || applicantId;

               // Ensure all required login flags are set (RestDataSource should have done this, but ensure it)
               await setValue('isloggedin', true);
               await setValue('roleCode', 'candidate');
               await setValue('roleCodeList', ['candidate']);
               await setValue('rolePriorityList', []);

               if (applicantId) {
                    await setValue('applicantId', applicantId);
               }
               if (userId) {
                    await setValue('userId', userId);
               }

               // Verify the data was saved before redirecting - try multiple times
               let verifyData = null;
               let retries = 0;
               const maxRetries = 5;

               while (retries < maxRetries) {
                    try {
                         verifyData = await getValue();
                         if (verifyData && verifyData.isloggedin === true && verifyData.roleCode === 'candidate') {
                              console.log('Login data verified successfully');
                              break;
                         }
                    } catch (error) {
                         console.warn('Error verifying login data, retry', retries + 1, error);
                    }

                    if (retries < maxRetries - 1) {
                         // Retry setting the values
                         await setValue('isloggedin', true);
                         await setValue('roleCode', 'candidate');
                         if (applicantId) {
                              await setValue('applicantId', applicantId);
                         }
                         // Wait a bit before retrying
                         await new Promise(resolve => setTimeout(resolve, 200));
                    }
                    retries++;
               }

               if (!verifyData || verifyData.isloggedin !== true) {
                    console.error('Failed to save login data after retries. Data:', verifyData);
                    // Still try to redirect - the checkIfLoggedIn will handle it
               }

               document.body.classList.remove('login-bg');

               // Use longer delay to ensure all async operations complete
               setTimeout(() => {
                    // hard redirect to avoid any routing issues
                    window.location.href = "/candidate/bgvForm/entry";
               }, 500);
          } catch (error) {
               console.error('Error in loginSuccess:', error);
               this.setState({ fullLoading: false, alertMsg: 'Login successful but redirect failed. Please refresh the page.' });
          }
     }

     changeStepValue = (stepValue) => {
          console.log("stepValue:", stepValue);

          this.setState({ step: stepValue }, () => {
               this.props.navigate(stepValue);
          });
     }

     showAlert = (alertMsg) => {
          this.setState({ alertMsg: alertMsg });
     }

     render = () => {

          console.log("Navigate  Link Prop", this.props);
          console.log("Step", this.state.step);
          let path = this.props.match.path !== '/' ? this.props.match.path : '/home';
          return (

               <React.Fragment>
                    {this.state.fullLoading ? <LoadingSpinner showBg="true" /> :
                         <React.Fragment>
                              <LoginHeader />
                              <div className="login-block">
                                   <div className="login-set">
                                        {
                                             this.state.loading === true ? <LoadingSpinner showBg="true" /> :
                                                  <React.Fragment>
                                                       {
                                                            (this.state.alertMsg) ? <BottomAlert status="danger" msg={this.state.alertMsg} /> : null
                                                       }
                                                       {
                                                            <Routes>
                                                                 <Route path={`verifyOtp/*`} element={<VerifyOTP {...this.props} match={`${path}/verifyOtp`} {...this.state.userdata} showAlert={this.showAlert} loginSuccess={this.loginSuccess} changeStepValue={this.changeStepValue} resendOTP={this.resendOTP} verifyOTP={this.verifyOTP} />} />
                                                                 <Route path={`login`} element={<LoginForm {...this.props} hideForgotPassword={true} cbValidateLogin={this.validateLogin} changeStepValue={this.changeStepValue} />} />
                                                                 <Route path="/" element={<Navigate to={this.state.step} />} />
                                                            </Routes>
                                                       }

                                                  </React.Fragment>
                                        }
                                   </div>
                                   <div className="clr"></div>
                              </div>
                         </React.Fragment>
                    }
                    <img className="loginbg" src={'/images/login-bg.svg'} alt='' />
                    {/* <LoginFooter /> */}

               </React.Fragment>
          );
     }
}
export default WithRouterHooks(CandidateLoginLayout);
